var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920X1080ActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13636 0C0.509091 0 0 0.509091 0 1.13636V10.2273C0 10.8545 0.509091 11.3636 1.13636 11.3636H14.7727C15.4 11.3636 15.9091 10.8545 15.9091 10.2273V1.13636C15.9091 0.509091 15.4 0 14.7727 0H1.13636ZM18.1818 0V2.27273H20.4545V15.9091H2.27273V13.6364H0V17.0455C3.01328e-05 17.3468 0.119763 17.6358 0.332866 17.849C0.545969 18.0621 0.834991 18.1818 1.13636 18.1818H21.5909C21.8923 18.1818 22.1813 18.0621 22.3944 17.849C22.6075 17.6358 22.7272 17.3468 22.7273 17.0455V1.13636C22.7272 0.834991 22.6075 0.545969 22.3944 0.332866C22.1813 0.119763 21.8923 3.01328e-05 21.5909 0H18.1818ZM25 0V2.27273H27.2727V22.7273H2.27273V20.4545H0V23.8636C3.01328e-05 24.165 0.119763 24.454 0.332866 24.6671C0.545969 24.8802 0.834991 25 1.13636 25H28.4091C28.7105 25 28.9995 24.8802 29.2126 24.6671C29.4257 24.454 29.5454 24.165 29.5455 23.8636V1.13636C29.5454 0.834991 29.4257 0.545969 29.2126 0.332866C28.9995 0.119763 28.7105 3.01328e-05 28.4091 0H25Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920X1080ActiveIcon);
export default __webpack_public_path__ + "static/media/1920X1080ActiveIcon.7792afb2c8a0eec1187be85bf97d6cd4.svg";
export { ForwardRef as ReactComponent };